var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7855 0.765047L74.4577 0.000696896C74.4577 0.000696896 65.0734 -0.155924 59.1843 4.22676C52.5161 9.18913 50.0067 15.5149 43.1882 19.482C36.3696 23.4492 29.1641 24.1776 29.1641 24.1776V62.4084L75.7855 0.765047Z",
    fill: "#A86300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5126 4.99238C53.8444 9.95495 51.335 16.2805 44.5164 20.2477C37.6977 24.2148 30.4922 24.9432 30.4922 24.9432V63.174C30.4922 63.174 37.6977 62.4456 44.5164 58.4785C51.335 54.5113 53.8442 48.1858 60.5126 43.2232C66.4015 38.8405 75.786 38.9971 75.786 38.9971V0.766322C75.7859 0.766322 66.4015 0.609701 60.5126 4.99238Z",
    fill: "#F99302"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5828 22.8516L23.2109 23.6385V96.9403L23.2127 96.9401C23.2169 97.4912 23.5501 98.0171 24.2315 98.4104C25.7453 99.2844 28.3895 99.1748 30.1373 98.1656C31.106 97.6064 31.594 96.8883 31.5807 96.2102L31.5828 96.21V22.8516Z",
    fill: "#C2CDDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1387 24.8122C31.8866 23.8031 32.0765 22.2765 30.5627 21.4025C29.0489 20.5285 26.4047 20.6382 24.6569 21.6473C22.909 22.6565 22.7191 24.183 24.2329 25.057C25.7467 25.931 28.3907 25.8214 30.1387 24.8122Z",
    fill: "#667790"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4173 39.1507L48.5284 44.8974L40.5469 26.9961L53.1545 21.3748L54.8876 25.2619L46.832 28.8536L48.1547 31.8201L54.4969 28.9924L56.23 32.8795L49.8878 35.7073L51.3473 38.9806L59.6842 35.2635L61.4173 39.1507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE);
export default __webpack_public_path__ + "static/media/e.fc04bf1b8002373bac723c869c3641c8.svg";
export { ForwardRef as ReactComponent };